import { Component, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { BaseSectionComponent } from 'app/shared/base-classes/sections/base-section.component';
import { SingleDropdownComponent } from 'app/shared/components/dropdowns/single-dropdown/single-dropdown.component';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';
import {
	VEHICLE_DRIVE_TRAIN_TYPE,
	VEHICLE_POWER_PLANT_TYPE,
	VEHICLE_TRANSMISSION_TYPE,
} from '../../../translations/vehicles-select-items';

@Component({
	selector: 'app-vehicles-power-plant',
	templateUrl: 'vehicles-power-plant.component.html',
	imports: [
		ReactiveFormsModule,
		SingleDropdownComponent,
		SectionWrapperComponent,
	],
})
export class VehiclesPowerPlantComponent
	extends BaseSectionComponent<VehicleRecordModel>
	implements OnInit
{
	powerPlant = VEHICLE_POWER_PLANT_TYPE;
	driveTrainType = VEHICLE_DRIVE_TRAIN_TYPE;
	transmissionType = VEHICLE_TRANSMISSION_TYPE;
	protected _skipCount: number = 0;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			primaryPowerPlantType: [null],
			secondaryPowerPlantType: [null],
			driveTrainType: [null],
			transmissionType: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			primaryPowerPlantType: this.recordData().primaryPowerPlantType,
			secondaryPowerPlantType: this.recordData().secondaryPowerPlantType,
			driveTrainType: this.recordData().driveTrainType,
			transmissionType: this.recordData().transmissionType,
		};
		this.detailsForm.setValue(detailsFormData, {
			emitEvent: false,
		});
	}

	protected _mapFormToModel(): Partial<VehicleRecordModel> {
		return {
			primaryPowerPlantType: this.detailsForm.value.primaryPowerPlantType,
			secondaryPowerPlantType: this.detailsForm.value.secondaryPowerPlantType,
			driveTrainType: this.detailsForm.value.driveTrainType,
			transmissionType: this.detailsForm.value.transmissionType,
		};
	}
}
